import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  body: {
    width: '100%',
    '@media(max-width: 450px)': {
      width: 'auto',
    },
  },
  modalTitle: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
    },
    letterSpacing: '0.02rem',
    marginBottom: '0.4rem',
    marginTop: '2rem',
    textAlign: 'center',
  },
  subtitle: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    textAlign: 'center',
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    padding: '0.4rem 0 3.6rem 0',
    maxWidth: '55rem',
    margin: '0 auto 0',
  },
  form: {
    marginBottom: '4rem',
    display: 'flex',
    flexDirection: 'column',

    [breakpoints.lg.down]: {
      marginBottom: '2rem',
    },
  },
  fullInputLayout: {
    width: 'auto',
    padding: '0 1.2rem 3.6rem 1.2rem',
    [breakpoints.md.down]: {
      padding: '0 1.2rem 2rem 1.2rem',
    },
  },
  footer: {
    margin: [0],
    marginTop: '0.4rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionsBlock: {
    margin: [0],
    maxWidth: '42.4rem',
    display: 'flex',
    gap: '2.4rem',
    justifyContent: 'center',
    '@media(max-width: 540px)': {
      maxWidth: '100%',
      width: '100%',
      '& button': {
        width: '50%',
        minWidth: 'auto',
      },
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
